module.exports = __webpack_public_path__ + "static/assets/a342f446d26393a5f18bb008aeaba447.svg";